import React from 'react';
import './Button.css';


const Button = ({children, onMouseEnter, onClick, disabled=false, className="", style={}, pill=false, smallShadow=false}) => {
  // const [state, setState] = useState(null);
  let cl = "Button " + className
  cl += pill ? " pill" : ""
  cl += smallShadow ? " small-shadow" : ""

  return (
    <button className={cl} disabled={disabled} onMouseEnter={onMouseEnter} onClick={onClick} style={style}>
      {children}
    </button>
  );
};

export default Button;